import api from '../../api/api';
import type { Category } from '../../types/types';

export const getProductCategories = async (): Promise<Category[]> => {
  try {
    const response = await api.get('/products/categories/');
    if (!response.data || !Array.isArray(response.data)) {
      console.warn("Kutilgan category ma'lumotlari topilmadi:", response.data);
      return []; // fallback bo‘sh array
    }
    console.log(response.data);
    return response.data;

} catch (error) {
    console.warn("Kategoriya olishda xatolik:", error);
    return []; // fallback bo'sh array
  }
};

export const getProductCategoriesId = async (id: number, page = 1) => {
  const response = await api.get(`/products/category-products/${id}/?page=${page}`);
  return response.data; // { results, next, previous, count }
};

export const getCategoryBanner = async (id: number) => {
  const response = await api.get(`/products/banners/${id}/`);
  return response.data;
};